import axios from 'axios';

// If REACT_APP_API_URL is empty/unset, use a relative path so all API calls
// stay on the same origin and protocol as the page (avoids mixed-content errors).
const apiOrigin = process.env.REACT_APP_API_URL || '';

const http = axios.create({
  withCredentials: true,
  baseURL: `${apiOrigin}/api/${process.env.REACT_APP_API_VERSION}`,
  headers: {
    'Content-Type': 'application/json'
  },
});

http.interceptors.response.use(
  response => response.data,
  error =>
    error.response
      ? Promise.reject({...error.response.data, status: error.response.status})
      : Promise.reject(error),
);

export default http;

export const limit = 50;